/* eslint-disable */
// import libs
import React, { useEffect } from 'react';
import { Table } from 'antd';
import 'antd/dist/antd.css';

// import css
import './CustomTableComponent.css';

let lastIndex = 0
const updateIndex = () => {
  lastIndex++
  return lastIndex
}

const CustomTableComponent = props => {
  const { optionsConfig, columns, data, scrollHeight, clickedRow } = props;
  useEffect(() => {
    if (document.querySelectorAll('.ant-table-column-sorter-full').length) {
      document
        .querySelectorAll('.ant-table-column-sorter-full')
        .forEach(e => e.remove());
    }
  });
  return (
    <React.Fragment>
      <Table
        rowKey = {updateIndex}
        pagination={false}
        columns={columns}
        dataSource={data}
        scroll={scrollHeight}
        locale={{
          emptyText: (<span>
            No Data Found
          </span>)
        }}
        showSorterTooltip={false}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              clickedRow(record, rowIndex);
            }, // click row
            onDoubleClick: event => {}, // double click row
            onContextMenu: event => {}, // right button click row
            onMouseEnter: event => {}, // mouse enter row
            onMouseLeave: event => {}, // mouse leave row
          };
        }}
      />
    </React.Fragment>
  );
};

export default CustomTableComponent;



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/CustomTableComponent.jsx